import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import LoadingSpinner from "./components/LoadingSpinner";
import ToastProvider from "./components/ToastProvider";
import ProtectedRoute from "./components/ProtectedRoute";
import SeoHead from "./components/SeoHead";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { isElectron } from "./utils/electronEnv";

const recaptchaSiteKey = isElectron() ? "" : process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
const recaptchaUseNet = process.env.REACT_APP_RECAPTCHA_USE_RECAPTCHA_NET === "true";

const LegalLogin = lazy(() => import("./pages/auth/LegalLogin"));
const LegalRegister = lazy(() => import("./pages/auth/LegalRegister"));
const LegalDashboard = lazy(() => import("./pages/legal/LegalDashboard"));
const LegalProfile = lazy(() => import("./pages/legal/LegalProfile"));

/**
 * Standalone legal transcription SPA (deploy at legal.scribeinai.com).
 */
export default function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey}
        useEnterprise={false}
        useRecaptchaNet={recaptchaUseNet}
        scriptProps={{ async: true, defer: true }}
      >
        <ToastProvider>
          <div className="min-h-screen flex flex-col">
            <GoogleAnalytics />
            <SeoHead page="home" />
            <main className="flex-1 w-full min-w-0 overflow-x-hidden">
              <Suspense fallback={<LoadingSpinner fullScreen text="Loading…" />}>
                <Routes>
                  <Route path="/" element={<LegalLogin />} />
                  <Route path="/login" element={<LegalLogin />} />
                  <Route path="/register" element={<LegalRegister />} />
                  <Route
                    path="/legal-dashboard"
                    element={
                      <ProtectedRoute tokenOnly>
                        <LegalDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/LegalDashboard"
                    element={
                      <ProtectedRoute tokenOnly>
                        <LegalDashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute tokenOnly>
                        <LegalProfile />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            </main>
          </div>
        </ToastProvider>
      </GoogleReCaptchaProvider>
    </Router>
  );
}
